/** Merge notification API `data` and `deepLink` maps (same rules as mobile AppNotification handling). */
export function mergeNotificationPayload(notification) {
  const raw = notification && typeof notification === "object" ? notification : {};
  const data =
    raw.data && typeof raw.data === "object" && !Array.isArray(raw.data)
      ? raw.data
      : {};
  const deepLink =
    raw.deepLink &&
    typeof raw.deepLink === "object" &&
    !Array.isArray(raw.deepLink)
      ? raw.deepLink
      : {};
  return { ...data, ...deepLink };
}

export function normalizeNotificationsResponse(body) {
  if (body == null) return [];
  if (Array.isArray(body)) return body;
  if (typeof body === "object") {
    if (Array.isArray(body.items)) return body.items;
    if (Array.isArray(body.notifications)) return body.notifications;
  }
  return [];
}
